<template>
  <div class="shishigaojing-energybox">
    <title1 type="1" title="实时告警" />
    <div class="sub-box">
		<div class="top">
			<div class="left">
				<div class="text">
					<p >{{infoObj.pcs}}</p>
					PCS变流器
				</div>
				<div class="img">
					<img src="@/assets/images/energyStorage/gpuimg.png" alt="">
				</div>
			</div>
			<div class="right">
				<div class="text">
					<p >{{infoObj.emu}}</p>
					EMU
				</div>
				<div class="img">
					<img src="@/assets/images/energyStorage/gpuimg.png" alt="">
				</div>
			</div>
		</div>
		<div class="bottom">
			<div class="cell">
				<div class="left">
					<img src="@/assets/images/energyStorage/dianchidui.png" alt="">
				</div>
				<div class="right">
					<div class="text">
						<p>电池堆</p>
						<span class="number">{{infoObj.battery}}</span>
					</div>
				</div>
			</div>
			<div class="cell">
				<div class="left">
					<img src="@/assets/images/energyStorage/dianbiao.png" alt="">
				</div>
				<div class="right">
					<div class="text">
						<p>电表</p>
						<span class="number">{{infoObj.meter}}</span>
					</div>
				</div>
			</div>
			<div class="cell">
				<div class="left">
					<img src="@/assets/images/energyStorage/wenshidu.png" alt="">
				</div>
				<div class="right">
					<div class="text">
						<p>温湿度</p>
						<span class="number">{{infoObj.humiture}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1,
  },
  data() {
    return {
		infoObj:{}
	};
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  mounted() {
    // this.$bus.$on("onfangdiangonglv", () => {
    //   this.getShishigaojing();
    // });
	
	this.getShishigaojing()
  },
  methods: {
	  getShishigaojing() {
		  let _this = this
		  let params = {
		  	'enCode': "chuneng-quanguo-ssgj"
		  }
		  dataInterface.dataFaceApi(params).then((res) => {
		  	if (!res || !res.length) return
				this.infoObj = res[0]
		  })
		  .catch((err) => {
		  	console.log(err, 'error');
		  })
	  }
  },
};
</script>

<style lang="scss" scope>
@import "@/views/components/energyStorage/comm.scss";
.shishigaojing-energybox {
	width: 100%;
	height: 100%;
	.sub-box{
		margin-top: 20px;
		padding: 0 10px;
		.top{
			height: 250px;
			width: 570px;
			display: flex;
			text-align: center;
			.left{
				flex: 1;
				img{
					width: 200px;
					height: 180px;
				}
			}
			.right{
				flex: 1;
				img{
					width: 200px;
					height: 180px;
				}
			}
			.text{
				font-size: 24px;
				p{
					// font-weight: 600;
					font-size: 32px;
					height: 30px;
					line-height: 30px;
					color: #31C6C9;
					font-family: 'HT';
					
				}
			}
		}
		.bottom{
			height: 75px;
			width: 570px;
			display: flex;
			font-size: 20px;
			.cell{
				flex: 1;
				display: flex;
				background: rgba(255,255,255,0.05);
				margin-right: 10px;
				.left{
					img{
						width: 60px;
						height: 60px;
						margin-top: 8px;
						margin-left: 8px;
						margin-right: 14px;;
					}
				}
				.right{
					.text{
						p{
							height: 31px;
							line-height: 46px;
							font-size: 24px;
						}
						.number{
							color: #31C6C9;
							font-size: 32px;
							// font-weight: 600;
							font-family: 'HT';
						}
					}
				}
			}
		}
	}
}
</style>
